import {
  STATUS
} from '../constants'
import { isEmpty } from 'lodash'

/*
  Helper functions for event, market, outcome to check is entity visible
*/
export function isVisible (entity) {
  return entity.status !== STATUS.HIDDEN
}

export function isHidden (entity) {
  return entity.status === STATUS.HIDDEN
}

/*
  Helper functions for event, market, outcome to check is entity suspended
*/
export function isSuspended (entity) {
  return entity.status === STATUS.SUSPENDED
}

export function isUnsuspended (entity) {
  return entity.status !== STATUS.SUSPENDED
}

/*
  Helper functions to check is active or not
*/

export function isActive (entity) {
  return entity.status === STATUS.ACTIVE
}

export function isInactive (entity) {
  return entity.status !== STATUS.ACTIVE
}

/*
  Helper functions for event to check if the event has marketTypes
*/
export function hasMarketTypes (event) {
  return !isEmpty(event?.marketTypes) && event?.marketTypesCount > 0
}
